import React from 'react';
import Content from '../../components/Pages/Dashboard';
import { displayName } from '../../../App';
import MainGuidanceLayout from '../../components/Layout/Main';

function Dashboard() {
  document.title = `${displayName}: Dashboard`;

  return (
    <MainGuidanceLayout>
      <Content />
    </MainGuidanceLayout>
  );
}

export default Dashboard;
